export enum FrameworkModule {
    SPACE_UI = 'space-ui',
    XR_UI = 'xr-ui',
    COMMUNICATION_UI = 'communication-ui',
}
